import { useState, Fragment, useEffect } from "react";
import { Tooltip, IconButton, Box, Collapse } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/AddCircleOutline';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { makeStyles } from '@material-ui/core/styles';
import { yellow } from "@material-ui/core/colors";
import { useSelector, useDispatch } from "react-redux";
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
import {
    targetClienteAction,
    eliminarClienteCotizadorAction,
    obtenerNoInteresadosPaginaAction,
    obtenerNoInteresadosRegistrosAction,
    obtenerClientesCotizadorAction,
    obtenerClientesCotizadorAllAction,
    modalViewCotizadorAction,
    obtenerNoInteresadosAction
} from "../../../ducks/cotizadorDuck";
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import TCotizaciones from "../TCotizaciones"

export const TClientesStyle = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: "65vh",
    },
    ButtonContent: {
        display: "flex",
        flexFlow: "column wrap",
        justifyContent: "center",
        alignItems: "center",
    },
    section1: {
        margin: theme.spacing(1, 2),
    },
    section2: {
        margin: theme.spacing(1, 2),
    },
}))
const columns = [
    {
        id: "numero",
        minWidth: 50,
        align: "center",
        label: "#",
    },
    // {
    //     id: "id",
    //     minWidth: 50,
    //     align: "center",
    //     label: "Id",
    // },
    {
        id: "NombreCliente",
        minWidth: 150,
        align: "center",
        label: "Nombre cliente",
    },
    { id: "email", minWidth: 10, align: "center", label: "Email" },
    { id: "fecha", minWidth: 50, align: "center", label: "Telefono" },
    { id: "noCotizacion", minWidth: 10, align: "center", label: "Cotizacion" },
    { id: "mod", minWidth: 30, align: "center", label: "" },
    { id: "Accion", minWidth: 10, align: "center", label: "" },
]
const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },

})
function Row(props) {
    const {
        row,
        index
    } = props;
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const classes = useRowStyles();

    const handleNuevaCotizacion = ({ cliente }) => {
        dispatch(targetClienteAction({ cliente, vista: 1, editar: false }))
        dispatch(modalViewCotizadorAction({ open: true, update: false, idCotizacion: 0 }))
    }
    const handleEditar = (cliente) => {
        dispatch(targetClienteAction({ cliente, vista: 1, editar: true }))
    }

    const handleEliminar = ({ id }) => {
        DialogMessage.fire({
            title: '¿Estas seguro de eliminar a es cliente?',
            text: "",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(eliminarClienteCotizadorAction({ idCliente: id })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    dispatch(obtenerClientesCotizadorAction())
                    dispatch(obtenerClientesCotizadorAllAction())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }

    return (
        <Fragment>
            <TableRow className={classes.root} hover>
                <TableCell align="center">{index}</TableCell>
                {/* <TableCell align="center">{row.IdCliente}</TableCell> */}
                <TableCell align="center">{row.Nombre}</TableCell>
                <TableCell align="center">
                    {row.EMail}
                </TableCell>
                <TableCell align="center">
                    {row.Telefono}
                </TableCell>
                <TableCell align="center">
                    {row.lCotizacion.length}
                </TableCell>
                <TableCell align="center">
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                        {
                            (false) &&
                            <Tooltip title="Editar Cliente">
                                <IconButton aria-label="delete" onClick={() => handleEditar(row)}>
                                    <EditIcon style={{ color: yellow[500] }} />
                                </IconButton>
                            </Tooltip>
                        }
                        {
                            (false) &&
                            <Tooltip title="Eliminar Cliente">
                                <IconButton aria-label="delete" onClick={() => handleEliminar({ id: row.IdCliente })}>
                                    <DeleteIcon color="error" />
                                </IconButton>
                            </Tooltip>
                        }
                        <Tooltip title="Nueva Cotizacion">
                            <IconButton aria-label="nuevaCotizacion" variant="outlined" color="primary" onClick={() => handleNuevaCotizacion({ cliente: row })}>
                                <AddIcon color="primary" />
                            </IconButton>
                        </Tooltip>
                    </div>

                </TableCell>
                <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            {
                                (row?.lCotizacion.length === 0) ? <h3 style={{ textAlign: "center" }}>Aun no hay cotizaciones</h3>
                                    : <TCotizaciones cliente={row} rows={row?.lCotizacion} />
                            }
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    );
}
const useClientesNoInteresados = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerNoInteresadosAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
export const TClientesNointeresados = () => {
    const { listaNoInteresados, paginaNoInteresados, registrosNoInteresados, totalNoInteresados } = useSelector(store => store.cotizador)
    const dispatch = useDispatch()
    const classes = TClientesStyle()
    const rows = listaNoInteresados
    useClientesNoInteresados()
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerNoInteresadosPaginaAction({ pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerNoInteresadosRegistrosAction({ registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            rows
                                .map((row, index) => {
                                    return (
                                        <Row
                                            index={index + 1}
                                            key={row.IdCliente}
                                            row={row}
                                        />
                                    );
                                })
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={totalNoInteresados}
                rowsPerPage={registrosNoInteresados}
                page={paginaNoInteresados}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}
export default TClientesNointeresados

